//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Creates a new recipe for the user.
 * @param dto Dto with data for creation.
 * @return Dto with recipe's data.
 */
export function create(dto: Types.CreateRecipeDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeInfoDto> {
    let url_ = getBaseUrl() + "/api/recipe";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateRecipeDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreate(_response);
    });
}

function processCreate(response: AxiosResponse): Promise<Types.RecipeInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeInfoDto(resultData200);
        return Promise.resolve<Types.RecipeInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeInfoDto>(null as any);
}

/**
 * Updates the recipe for the user.
 * @param recipeId Id of the recipe for update.
 * @param dto Dto with data for update.
 * @return Dto with recipe's data.
 */
export function update(recipeId: number, dto: Types.UpdateRecipeDto, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeInfoDto> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateRecipeDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdate,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigUpdate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdate(_response);
    });
}

function processUpdate(response: AxiosResponse): Promise<Types.RecipeInfoDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeInfoDto(resultData200);
        return Promise.resolve<Types.RecipeInfoDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeInfoDto>(null as any);
}

/**
 * Gets the recipe for the user.
 * @param recipeId Id of the recipe for get.
 * @return Dto with recipe's data.
 */
export function get(recipeId: number, config?: AxiosRequestConfig | undefined): Promise<Types.RecipeDto> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.RecipeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRecipeDto(resultData200);
        return Promise.resolve<Types.RecipeDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RecipeDto>(null as any);
}

/**
 * Deletes the recipe for the user.
 * @param recipeId Id of the recipe for update.
 * @return Dto with material's data.
 */
export function remove(recipeId: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemove,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemove?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemove(_response);
    });
}

function processRemove(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Moves the recipe to another folder.
 * @param recipeId Id of the recipe, that should be moved.
 * @param targetFolderId (optional) Target recipe folder id.
 */
export function moveRecipe(recipeId: number, targetFolderId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/move?";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (targetFolderId === null)
        throw new Error("The parameter 'targetFolderId' cannot be null.");
    else if (targetFolderId !== undefined)
        url_ += "targetFolderId=" + encodeURIComponent("" + targetFolderId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigMoveRecipe,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigMoveRecipe?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processMoveRecipe(_response);
    });
}

function processMoveRecipe(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Copies the recipe to selected folder.
 * @param recipeId Id of the recipe, that should be moved.
 * @param targetFolderId (optional) Target recipe folder id.
 */
export function copyRecipe(recipeId: number, targetFolderId?: number | undefined, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/copy?";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
    if (targetFolderId === null)
        throw new Error("The parameter 'targetFolderId' cannot be null.");
    else if (targetFolderId !== undefined)
        url_ += "targetFolderId=" + encodeURIComponent("" + targetFolderId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCopyRecipe,
        ...config,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigCopyRecipe?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCopyRecipe(_response);
    });
}

function processCopyRecipe(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Returns all recipes of the user for export.
 * @param folderPublicId (optional) 
 */
export function getAllRecipesForExport(folderPublicId?: string | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PrintRecipeDto[]> {
    let url_ = getBaseUrl() + "/api/recipe/export?";
    if (folderPublicId !== undefined && folderPublicId !== null)
        url_ += "folderPublicId=" + encodeURIComponent("" + folderPublicId) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAllRecipesForExport,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetAllRecipesForExport?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAllRecipesForExport(_response);
    });
}

function processGetAllRecipesForExport(response: AxiosResponse): Promise<Types.PrintRecipeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
              result200 = resultData200.map(item => 
                Types.initPrintRecipeDto(item)
              );
            }
        return Promise.resolve<Types.PrintRecipeDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PrintRecipeDto[]>(null as any);
}

/**
 * Toggles Published.
 * @param recipeId Id of the Recipe to change.
 * @return New Published state.
 */
export function togglePublishedState(recipeId: number, config?: AxiosRequestConfig | undefined): Promise<boolean> {
    let url_ = getBaseUrl() + "/api/recipe/{recipeId}/toggle-published";
    if (recipeId === undefined || recipeId === null)
      throw new Error("The parameter 'recipeId' must be defined.");
    url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigTogglePublishedState,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigTogglePublishedState?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processTogglePublishedState(_response);
    });
}

function processTogglePublishedState(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<boolean>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
}
let _requestConfigCreate: Partial<AxiosRequestConfig> | null;
export function getCreateRequestConfig() {
  return _requestConfigCreate;
}
export function setCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreate = value;
}
export function patchCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreate = patch(_requestConfigCreate ?? {});
}

let _requestConfigUpdate: Partial<AxiosRequestConfig> | null;
export function getUpdateRequestConfig() {
  return _requestConfigUpdate;
}
export function setUpdateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = value;
}
export function patchUpdateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdate = patch(_requestConfigUpdate ?? {});
}

let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigRemove: Partial<AxiosRequestConfig> | null;
export function getRemoveRequestConfig() {
  return _requestConfigRemove;
}
export function setRemoveRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemove = value;
}
export function patchRemoveRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemove = patch(_requestConfigRemove ?? {});
}

let _requestConfigMoveRecipe: Partial<AxiosRequestConfig> | null;
export function getMoveRecipeRequestConfig() {
  return _requestConfigMoveRecipe;
}
export function setMoveRecipeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigMoveRecipe = value;
}
export function patchMoveRecipeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigMoveRecipe = patch(_requestConfigMoveRecipe ?? {});
}

let _requestConfigCopyRecipe: Partial<AxiosRequestConfig> | null;
export function getCopyRecipeRequestConfig() {
  return _requestConfigCopyRecipe;
}
export function setCopyRecipeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCopyRecipe = value;
}
export function patchCopyRecipeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCopyRecipe = patch(_requestConfigCopyRecipe ?? {});
}

let _requestConfigGetAllRecipesForExport: Partial<AxiosRequestConfig> | null;
export function getGetAllRecipesForExportRequestConfig() {
  return _requestConfigGetAllRecipesForExport;
}
export function setGetAllRecipesForExportRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAllRecipesForExport = value;
}
export function patchGetAllRecipesForExportRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAllRecipesForExport = patch(_requestConfigGetAllRecipesForExport ?? {});
}

let _requestConfigTogglePublishedState: Partial<AxiosRequestConfig> | null;
export function getTogglePublishedStateRequestConfig() {
  return _requestConfigTogglePublishedState;
}
export function setTogglePublishedStateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigTogglePublishedState = value;
}
export function patchTogglePublishedStateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigTogglePublishedState = patch(_requestConfigTogglePublishedState ?? {});
}